import api from "./apiBase";

function dashboard() {
  return api.get("/dashboards");
}

export {
  dashboard
}